import { render, staticRenderFns } from "./buildConfig.vue?vue&type=template&id=81790f6e&scoped=true"
import script from "./buildConfig.vue?vue&type=script&lang=js"
export * from "./buildConfig.vue?vue&type=script&lang=js"
import style0 from "./buildConfig.vue?vue&type=style&index=0&id=81790f6e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81790f6e",
  null
  
)

export default component.exports